import { useRecoilValue } from "recoil";
import { updateAIModules } from "common-lib";
import { DefectOptionItem } from "@types";
import { myAIModuleState, trainUuidState } from "../recoil/upgrade";
import { invalidateModuleServer } from "../services/aiServer";

type ModuleStage = "train" | "valid" | "preview";

// 모듈 desc의 현재 단계 (모드는 바꾸지 않고 그대로 보낼 때 사용)
export const descType = (desc: Record<string, any> | undefined): ModuleStage =>
  desc?.train ? "train" : desc?.infer ? "valid" : "preview";

// 옵션을 /sync로 AI 서버에 보낸다. 옵션 Save(AugOptionSection)와 이미지 미리보기 전환/복원(DefectPreview)이 같이 쓴다
export const useAIModuleSync = () => {
  const myAIModule = useRecoilValue(myAIModuleState);
  const trainUuid = useRecoilValue(trainUuidState);

  return async (options: Record<string, DefectOptionItem>, type: ModuleStage, desc: Record<string, any> = {}) => {
    const config = await (await fetch("/config.json")).json();
    const data = {
      train_id: trainUuid,
      site: config.SITE_OPTION,
      options: Object.fromEntries(
        Object.entries(options).map(([key, { name, desc, para, tag }]) => [key, { name, desc: desc ?? {}, para, tag }]),
      ),
      type,
      total_count: desc.total ?? 0,
      trained_count: desc.trained_count ?? 0,
      is_complete: desc.is_complete ?? false,
    };

    const module = { ...myAIModule, options: { ...myAIModule?.options, ...data.options } };
    const updateResult = await updateAIModules(myAIModule!.serverAddress, data, module);
    console.log("updateResult", type, updateResult?.sentData);
    if (!updateResult) throw new Error("AI 모듈 업데이트에 실패했습니다.");
    invalidateModuleServer(); // 모듈이 바뀌었으니 다음 조회는 새로 받는다
  };
};
